import script from "./A11yLiveRegion.vue?vue&type=script&setup=true&lang=ts"
export * from "./A11yLiveRegion.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__